<template>
    <div class="py-0 mt-4 mb-8">
        <v-container class="mx-0 my-0" style="padding:0 !important; max-width: 100% !important">
            <v-card class="mt-1 pt-1 pb-10 px-0 size" style="margin-bottom: 35px !important" align="center" v-if="appointment != null">
                <v-row class="px-3 py-4 text-center" justify="center" align="center">
                    <v-col cols="6" class="py-1" justify="center" align="center">
                        <span justify="center" class="pr-1 text-uppercase blue_accent--text font-weight-bold">
                            {{ $t('pending_out.check_out') }} 
                        </span> 
                    </v-col>
                </v-row>
                <v-col cols="6" justify="start" align="start" class="px-0">
                    <v-row>
                        <v-col cols="6" class="py-1">
                            <span justify="center" class="pr-1 blue_accent--text text--uppercase font-weight-bold" style="font-size:18px">
                                {{ $t('pending_out.general_data') }} 
                            </span>
                        </v-col>
                    </v-row>
                    <v-row>
                         <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('pending_out.appointment') }}: </span> {{ this.id }} </v-col>
                    </v-row>
                    <v-row>
                         <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('pending_out.client') }}: </span> {{ this.appointment.client.name }} </v-col>
                    </v-row>
                    <v-row>
                         <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('pending_out.estimated_date_of_arriving') }}: </span> {{ this.appointment.arrival_date }} </v-col>
                    </v-row>
                    <v-row>
                         <v-col v-if="$store.state.language == 'en'" cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('process_pendings.operation') }}: </span> {{ this.appointment.operation.description1 }} </v-col>
                         <v-col v-if="$store.state.language == 'es'" cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('process_pendings.operation') }}: </span> {{ this.appointment.operation.description }} </v-col>
                    </v-row>
                    <v-row>
                         <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('pending_out.container') }}: </span> {{ this.appointment.container_number }} </v-col>
                    </v-row>
                    <v-row>
                         <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('pending_out.description') }}: </span> {{ this.appointment.description }} </v-col>
                    </v-row>
                    <v-row>
                         <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('pending_out.comments') }}: </span> {{ this.appointment.commentary }} </v-col>
                    </v-row>
                </v-col>
                <v-col class="py-5 px-0" cols="6" justify="start" align="start">
                    <v-row>
                        <v-col cols="12" class="py-1">
                            <span justify="center" class="pr-1 blue_accent--text font-weight-bold" style="font-size:18px">
                                {{ $t('pending_out.products') }} 
                            </span>
                        </v-col>
                    </v-row>
                    <datatable :props="{headers:appointment.operation.format_type == 'Salida' ? headers_outcome : headers_sku, items: products}" @methodHandler="methodHandler"></datatable>   
                </v-col>
                <v-col class="py-5 px-0" cols="6" justify="center" align="center">
                    <v-row align="end" justify="end">
                        <btn-sf :label="'pending_out.download_pdf'" @click="downloadPdf" v-permission:any="'n_pdf.show|n_pdf.index|i_pdf.show|i_pdf.index'" class="mr-2"></btn-sf>
                        <btn-pf :label="'pending_out.complete'" @click="update" v-permission="'op_pending_out.update'"></btn-pf>
                    </v-row>
                </v-col>
            </v-card>
            <bottom-bar ref="bottombar" :from="from" :m_type="m_type"></bottom-bar>
        </v-container>
        <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :timeout="snackbar.timeout">
            {{ snackbar.text }}
            <v-btn color="white" text @click="snackbar.visible = false">
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>

import JSZip from 'jszip';
import FileSaver from 'file-saver';

import { appointmentShowUseCase } from '../../application/use_cases/appointment_show_use_case';
import { appointmentSetStatusUseCase } from '../../application/use_cases/appointment_set_status_use_case';
import { HttpAppointmentRepository } from '../../infrastructure/appointment_repository';

export default {
    computed: {
        headers_sku: function(){
            return [
                {text: this.$t('process_pendings.sku'), value: 'sku_p', class: 'text-uppercase'},
                {text: this.$t('process_pendings.pieces'), value: 'quantity', class: 'text-uppercase'},
                {text: this.$t('process_pendings.unit'), value: 'unit', class: 'text-uppercase'}
            ];
        },
        headers_outcome: function(){
            return [
                {text: this.$t('process_pendings.sku'), value: 'sku_p', class: 'text-uppercase'},
                {text: this.$t('process_pendings.pieces'), value: 'quantity', class: 'text-uppercase'},
                {text: this.$t('process_pendings.batch'), value: 'batch', class: 'text-uppercase'},
                {text: this.$t('process_pendings.expiration'), value: 'reference', class: 'text-uppercase'},
            ];
        }
    },
    data(){
        return {
            id: this.$route.params.id,
            from: this.$route.params.from,
            m_type: this.$route.params.m_type,
            snackbar: {
                visible: false,
                color: 'primary',
                timeout: 2000,
                text: ''
            },
            appointment: null,
            movements: [],
            items_g: [],
            products: [],
            racks: []
        }
    },
    mounted(){
        this.$store.state.module = "headers.process_output_operation";
        localStorage.setItem('bottom', 4);
        this.$store.state.bottom = 4;
        this.index();
    },
    methods: {
        back(){
            this.$router.push('/operation/on-enclosure/' + this.from + "/" + this.m_type);
        },
        methodHandler(object){
            this[object.methodName](object.parameters);
        },
        async index(){
            try{
                this.appointment = await appointmentShowUseCase(this.id, HttpAppointmentRepository);

                await this.loadProducts();
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async loadProducts() {
            if(this.appointment.operation.format_type == "Entrada"){
                if(this.appointment.unknown_products == true){
                    var p = {};
                    if(this.appointment.standby_products[0].attributes.unknownProducts.boxes > 0){
                        console.log("OKOKK")
                        p = {
                            sku_p: this.$t('process_pendings.boxes'),
                            quantity: this.appointment.standby_products[0].attributes.unknownProducts.boxes
                        }
                        this.products.push(p);
                    }
                    else if(this.appointment.standby_products[0].attributes.unknownProducts.pallets > 0){
                        p = {
                            sku_p: this.$t('process_pendings.pallets'),
                            quantity: this.appointment.standby_products[0].attributes.unknownProducts.pallets
                        }
                        this.products.push(p);
                    }
                    else if(this.appointment.standby_products[0].attributes.unknownProducts.containers > 0){
                        p = {
                            sku_p: this.$t('process_pendings.containers'),
                            quantity: this.appointment.standby_products[0].attributes.unknownProducts.containers
                        }
                        this.products.push(p);
                    }
                }
                else{
                    this.appointment.standby_products.forEach(x => 
                    {
                        x = x.attributes;
                        var p = {};
                        p = {
                            sku_p: x.product.sku,
                            quantity: x.quantity,
                            unit: x.product.unit
                        }
                                    
                        this.products.push(p);
                    });
                }
            } 
            else if(this.appointment.operation.format_type == "Salida"){
                this.appointment.detail_orders.forEach(x => 
                {
                    x = x.attributes;
                    var p = {};
                    p = {
                        sku_p: x.product.sku,
                        quantity: x.expected,
                        unit: x.product.unit
                    }
                                
                    this.products.push(p);
                });
            }
        },
        async update(){
            if(this.products.length == 0) return;
            
            try{
                var appointment = {
                    status: 'Procesando',
                    newStatus: 'Procesando',
                    gate_id: null
                }

                if(this.appointment.operation.id == 5){
                    appointment.newStatus = "Procesada";
                    appointment.status = "Procesada"
                }
                else if(this.appointment.operation.id == 6){
                    appointment.newStatus = "Completo";
                    appointment.status = "Completo"
                }
                else {
                    appointment.newStatus = "Pendiente Anexo24";
                    appointment.status = "Pendiente Anexo24"
                }
                
                const res = await appointmentSetStatusUseCase(this.id, appointment, HttpAppointmentRepository);
                res;
                
                this.$router.push('/operation/pendings/' + this.from + "/" + this.m_type);
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.message
                }
            }
        },
        downloadPdf(){
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.$http.get(this.$store.state.chronosApi + 'appointments/' + this.id + "/pdf?simple=true", {headers: {Authorization: lsToken}, responseType: 'arraybuffer'})
            .then((response) => {
                this.forceFileDownloadHistory(response, this.id)
            })
            .catch((response) => {
                this.$store.state.loaderProps.visible = false;
                if(response.status !== 200){
                    this.snackbar = {
                        visible: true,
                        color: 'red',
                        text: this.$t('pendings.responses.error')
                    }
                }
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            });
        },
        forceFileDownloadHistory(response, id){
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            this.$store.state.loaderProps.visible = false
            link.href = url
            link.setAttribute('download', 'Appointment - ' + id + '.pdf')
            document.body.appendChild(link)
            link.click()
        },
        async getLabel(){
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            const response = await this.$http.get(this.$store.state.chronosApi + 'appointments/pallets_information/' + this.id, {headers: {Authorization: lsToken}})
            var zip = new JSZip();
            
            if(response.data.status != 200){
                this.$store.state.loaderProps.visible = false;
                return;
            }

            for(var i = 1; i <= response.data.pallets.length; i++){
                const file = await this.getFileLabel(response.data.appointment, response.data.pallets[i-1]);
                zip.file(response.data.appointment.id + '_' + i + '.png', file.data);
            }

            zip.generateAsync({type:"blob"}).then(function(content) {
                FileSaver.saveAs(content, "Labels_appointment_" + response.data.appointment.id + ".zip")
            }, function(err){
                console.log(err)
            })

            this.$store.state.loaderProps.visible = false;
        },
        async getFileLabel(appointment, pallet){
            const lsToken = localStorage.getItem("access_token");
            const file = await this.$http.get(this.$store.state.chronosApi + 'appointments/get_label/png?pallet=' + pallet.pallet + '&container_number=' + appointment.container_number + '&name=' + appointment.name + '&arrival_date=' + appointment.arrival_date + '&id=' + appointment.id + '&sku=' + pallet.sku + '&batch=' + (pallet.batch ?? 'null') + '&reference=' + (pallet.reference ?? 'null') + '&operation_id=' + appointment.operation_id, {headers: {Authorization: lsToken}, responseType:'blob'});
            return file;
        }
    },
    watch:{
        'clients': function() {
            this.index();
        },
    }
}
</script>